import styled, { css } from 'styled-components';

interface IChart {
  color: string;
}

export const ChartContainer = styled.div`
  .labelLegend {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    font-size: 12px;
  }

  .funnel-pipeline-chart-title {
    color: black;
  }

  .funnel-pipeline-chart-value {
    color: black;
    font-weight: 500;
  }

  .legenda {
    flex: 1;
    font-size: 12px;
    margin-top: 10px;

    h3 {
      font-size: 12px;
    }
  }

  .legenda .lista {
    list-style: none;
    padding: 0;
    max-height: 300px;
    column-width: 150px;
    column-gap: 20px;
    overflow-y: auto;
  }

  .legenda .elemento {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    break-inside: avoid;
  }
`;

export const Icon = styled.div<IChart>`
  ${({ color }) => css`
    width: 15px;
    height: 15px;
    background-color: ${color};
    margin-right: 6px;
    border-radius: 2px;
    flex-grow: 0;
    flex-shrink: 0;
  `}
`;
